export enum ResourceType {
  DOCUMENT = 'DOCUMENT',
  VIDEO = 'VIDEO',
  SLIDES = 'SLIDES',
  PAGE = 'PAGE',
  GEOGEBRA_TEXT = 'GEOGEBRA_TEXT',
  WHITEBOARD = 'WHITEBOARD',
  GALLERY = 'GALLERY',
}

export interface AssetResourceInfo {
  type: ResourceType;
  url: string;
  key: string;
  title: string;
}

export interface AssetURL {
  problem: ProblemURL;
  subProblems: ProblemURL[];
  resourceInfo: AssetResourceInfo;
  downloadURL: string;
}

export interface ProblemURL {
  id: number;
  URL: string;
  height: number;
  width: number;
  positionAsLetter: string;
}

export interface AssetHTML {
  problem: ProblemHTML;
  subProblems: ProblemHTML[];
}

export interface ProblemHTML {
  id: number;
  HTML: HTMLDivElement;
  height: number;
  width: number;
}

export interface AppletURL {
  id: number;
  URL: string;
  height: number;
  width: number;
}
